import IconFlipHorizontal from '@picsart/icons/IconFlipHorizontal';
import IconFlipVertical from '@picsart/icons/IconFlipVertical';
import IconFlipRight from '@picsart/icons/IconFlipRight';
import IconFlipLeft from '@picsart/icons/IconFlipLeft';

import { RotationOptionEnum } from './types';

export const ROTATE_STEP = 90;
export const MAX_ROTATE = 360;

export const ROTATE_OPTIONS = [
  { name: 'Left', Icon: IconFlipLeft, action: RotationOptionEnum.rotateLeft },
  { name: 'Right', Icon: IconFlipRight, action: RotationOptionEnum.rotateRight },
  { name: 'Vertical', Icon: IconFlipVertical, action: RotationOptionEnum.flipVertical },
  { name: 'Horizontal', Icon: IconFlipHorizontal, action: RotationOptionEnum.flipHorizontal },
];
